import { Routing } from '../../../Core/js/common/adapters/legacy-to-modules-adapter';

const logMissed = (key) => {
  if (!LOG_TRANSLATIONS) {
    return;
  }

  // eslint-disable-next-line
  const { mapStackTrace } = require('../../../../node_modules/sourcemapped-stacktrace/dist/sourcemapped-stacktrace.js');

  mapStackTrace(new Error().stack, (mappedStack) => {
    const stack = JSON.stringify(mappedStack);
    const form = new FormData();
    // eslint-disable-next-line
    form.append('trace', stack);

    fetch(Routing.generate('visual_craft_videojet_log_translation', { key }), {
      method: 'POST',
      credentials: 'same-origin',
      body: form,
    });
  });
};

export default logMissed;



// WEBPACK FOOTER //
// ./assets/Translation/js/translator/logMissed.js